// src/mixins/videoAudioMixin.js
export default {
  data() {
    return {
      soundPermissionFlag: false,                         // 音声許可ウィンドウ表示フラグ
      windowActive: true,                                 // ウィンドウがアクティブかどうかのフラグ
      bgmStatusBeforeDeactivation: true,                  // ウィンドウが非アクティブだったときのBGMの状態
      mainPaused: false,                                  // mainVideoの再生状態を監視
      pipPaused: false                                    // pipVideoの再生状態を監視
    }
  },
  computed: {
    // 360メイン動画
    hasMainVideo() {
      return !!(this.jsonData && this.jsonData.mainVideo && this.jsonData.mainVideo.file);
    },
    // Picture-in-Picture動画
    hasPipVideo() {
      return !!(this.jsonData && this.jsonData.pipVideo && this.jsonData.pipVideo.file);
    },
    // BGMの有無
    hasBgm() {
      return !!(this.jsonData && this.jsonData.bgm && this.jsonData.bgm.file);
    },
    // JSON的に「音を出してよい設定」か（bgmStatus は考慮しない）
    mainWantsAudio() {
      return this.hasMainVideo && this.jsonData.mainVideo.audioEnabled === true;
    },
    pipWantsAudio() {
      return this.hasPipVideo && this.jsonData.pipVideo.audioEnabled === true;
    },
    // 実際に“今”音を出すべきか（JSONのmuteとbgmStatusのAND）
    mainShouldSoundNow() {
      return this.bgmStatus && this.mainWantsAudio;
    },
    pipShouldSoundNow() {
      return this.bgmStatus && this.pipWantsAudio;
    },
    // JSONが「BGMを鳴らす」と設定しているか（bgmStatusは考慮しない）
    bgmWantsAudio() {
      return this.hasBgm && this.jsonData.bgm.audioEnabled === true;
    },
    // 実際に“今”BGMを鳴らすべきか（グローバルスイッチと掛け合わせ）
    bgmShouldSoundNow() {
      return this.bgmStatus && this.bgmWantsAudio;
    }
  },
  watch: {
    /*******************************************
     * BGM許可ステータスに変更がある場合
     ******************************************/
    async bgmStatus() {
      // BGMコントロール処理を呼び出し
      this.bgmControl();
    },
    /*******************************************
     * Loadフラグが更新されたらアニメーションを設定
     ******************************************/
    async loadFlag(newBool) {
      // 初回アクセスなら必ず出す（ブラウザセッション内で一度も許可していない）
      const askedKey = 'askedVideoSound_session_v1';
      const askedThisSession = sessionStorage.getItem(askedKey) === '1';
      // iPhone/iPad の場合は常に音声許可ポップアップを表示
      const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
      if (isIOS || !askedThisSession) {
        this.soundPermissionFlag = true;
        sessionStorage.setItem(askedKey, '1');
        this.$store.dispatch('CampusStatus/setBgmStatus', false);
        localStorage.setItem('wantVideoSound', '0');
      }
      if (!newBool) return;
      // アニメーション設定＆不要ワープ非表示
      if (newBool) {
        for (let property in this.glbData.animation) {
          // アニメーションを設定
          await this.setAnimation(property);
        }
        // リンク情報の存在しないワープGLBを非表示
        this.delWarpGlbList.forEach((elem, index) => {
          let removeGlbWarp = document.getElementById(elem);
          removeGlbWarp.setAttribute('visible', false);
        });
        // loadFlagがtrueになった後に mainVideo & pipVideo を再生
        setTimeout(async () => {
          // ① mainVideo再生
          if (this.hasMainVideo) {
            const mainVideo = document.getElementById('mainVideo');
            mainVideo.muted = true;
            try {
              if (mainVideo.readyState < 2) {
                await new Promise(res => mainVideo.addEventListener('canplay', res, { once: true }));
              }
              await mainVideo.play();
              if (this.mainShouldSoundNow) mainVideo.muted = false;
            } catch (e) {
              console.log('mainVideo再生中エラー:', e);
            }
          }
          // ② Picture-in-Picture動画再生
          if (this.hasPipVideo) {
            const pip = document.getElementById('pipVideo');
            pip.muted = true;
            try {
              if (pip.readyState < 2) {
                await new Promise(res => pip.addEventListener('canplay', res, { once: true }));
              }
              await pip.play();
              if (this.pipShouldSoundNow) pip.muted = false;
            } catch (e) {
              console.log('pipVideo再生中エラー:', e);
            }
          }
          // ③ BGM（条件付き）
          if (this.hasBgm && this.bgmShouldSoundNow) {
            const bgm = document.getElementById('bgmSound');
            if (bgm) {
              try {
                if (bgm.readyState < 2) {
                  await new Promise(res => bgm.addEventListener('canplay', res, { once: true }));
                }
                await bgm.play().catch(() => {});
              } catch (e) {
                console.log('BGM play failed:', e);
              }
            }
          }
        }, 500);
      }
    },
    /*******************************************
     * ウィンドウのアクティブ状態の変更を監視
     ******************************************/
    windowActive(newActiveState) {
      // ウィンドウが非アクティブになったとき
      if (!newActiveState) {
        // ウィンドウが非アクティブになる直前のBGMの状態を保存
        this.bgmStatusBeforeDeactivation = this.bgmStatus;
        // BGMをミュートにする
        this.setBgmStatus(false);
      } else {
        // ウィンドウがアクティブになったとき
        // ウィンドウが非アクティブだったときのBGMの状態に戻す
        this.setBgmStatus(this.bgmStatusBeforeDeactivation);
      }
    },
    /*******************************************
     * mainVideo 停止検知
     ******************************************/
    async mainPaused(newVal) {
      if (newVal) {
        const main = document.getElementById('mainVideo');
        if (!main) return;
        try {
          console.warn('mainVideo 停止検知 → muted再生で復旧');
          main.muted = true;
          await main.play();

          // スピーカーOFFに整合
          this.$store.dispatch('CampusStatus/setBgmStatus', false);
          localStorage.setItem('wantVideoSound', '0');
        } catch (e) {
          console.log('mainVideo再生復旧失敗:', e);
        }
      }
    },
    /*******************************************
     * pipVideo 停止検知
     ******************************************/
    async pipPaused(newVal) {
      if (newVal) {
        const pip = document.getElementById('pipVideo');
        if (!pip) return;
        try {
          console.warn('pipVideo 停止検知 → muted再生で復旧');
          pip.muted = true;
          await pip.play();
        } catch (e) {
          console.log('pipVideo再生復旧失敗:', e);
        }
      }
    }
  },
  mounted() {
    /*******************************************
     * BGMコントロール処理を呼び出し
     ******************************************/
    this.bgmControl();

    /*******************************************
     * mainVideoのiOS再生対策
     ******************************************/
    const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
    if (this.hasMainVideo && isIOS) this.prepareMainVideo();

    /*******************************************
     * ウィンドウのフォーカスイベントを監視
     ******************************************/
    window.addEventListener('focus', () => {
      this.windowActive = true;
    });
    // ウィンドウのブラーイベントを監視
    window.addEventListener('blur', () => {
      this.windowActive = false;
    });

    /*******************************************
     * mainVideo / pipVideo の再生状態を監視
     ******************************************/
    setTimeout(() => {
      const main = document.getElementById('mainVideo');
      const pip  = document.getElementById('pipVideo');
      if (main) {
        main.addEventListener('play',  () => { this.mainPaused = false; });
        main.addEventListener('pause', () => { this.mainPaused = true; });
      }
      if (pip) {
        pip.addEventListener('play',  () => { this.pipPaused = false; });
        pip.addEventListener('pause', () => { this.pipPaused = true; });
      }
      // Safari/iOSブロック対策: 状態の食い違いを2秒ごとに確認
      setInterval(() => {
        if (main && main.paused !== this.mainPaused) this.mainPaused = main.paused;
        if (pip && pip.paused !== this.pipPaused) this.pipPaused = pip.paused;
      }, 2000);
    }, 5000); // ← 初期再生安定後に監視を始める
  },
  methods: {
    /*******************************************
     * BGM許可ステータスを設定
     ******************************************/
    async setBgmStatus(newBool) {
      // グローバル状態変更・UI閉じ
      this.$store.dispatch('CampusStatus/setBgmStatus', newBool);
      this.soundPermissionFlag = false;
      // ユーザー設定を保存
      localStorage.setItem('wantVideoSound', newBool ? '1' : '0');
      sessionStorage.setItem('askedVideoSound_session_v1', '1');
      // 実際の再生・ミュート制御を反映
      await this.bgmControl();
    },
    /*******************************************
     * フラグに変更があれば再生or一時停止処理
     ******************************************/
    async bgmControl() {
      const main = document.getElementById('mainVideo');
      const pip  = document.getElementById('pipVideo');
      const bgm  = document.getElementById('bgmSound');
      if (!this.loadFlag) return;
      if (this.bgmStatus) {
        // === 音声ON ===
        // main/pip は映像再生中のままミュート解除のみ
        if (main && this.mainWantsAudio) main.muted = false;
        if (pip && this.pipWantsAudio) pip.muted = false;
        // BGMはJSON設定がtrueなら再生
        if (bgm && this.bgmWantsAudio) {
          try {
            if (bgm.readyState < 2) {
              await new Promise(res => bgm.addEventListener('canplay', res, { once: true }));
            }
            await bgm.play();
          } catch (e) {
            console.log('BGM再生失敗:', e);
          }
        }
      } else {
        // === 音声OFF ===
        // main/pip は映像継続・音だけミュート
        if (main) main.muted = true;
        if (pip)  pip.muted  = true;
        // BGMは停止
        if (bgm)  bgm.pause();
      }
    },
    /*******************************************
     * mainVideoの自動再生を安定させるための事前準備（iOS対策）
     ******************************************/
    async prepareMainVideo() {
      if (!this.hasMainVideo) return;
      const mainVideo = document.getElementById('mainVideo');
      if (!mainVideo || !mainVideo.src) return;
      mainVideo.muted = true; // iOS自動再生条件
      try {
        await mainVideo.play(); // 再生を“開始”してパイプライン起動
      } catch (_) {
        // 失敗しても無視
      }
      // 最初のフレームが出るのを待つ
      await new Promise((res) => {
        if ('requestVideoFrameCallback' in mainVideo) {
          mainVideo.requestVideoFrameCallback(() => res());
        } else {
          const onFirst = () => { mainVideo.removeEventListener('timeupdate', onFirst); res(); };
          mainVideo.addEventListener('timeupdate', onFirst, { once: true });
        }
      });
      // ここで一時停止（デコード済み）
      mainVideo.pause();
      // iOSでたまに先頭フレーム保持が怪しい時の保険
      try { mainVideo.currentTime = Math.max(0, mainVideo.currentTime - 0.01); } catch (_) {}
    }
  }
}